__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['virtual-cards-recipient-journey-wrapper'].baseUrl;
import ModuleContainer from './components/VirtualCardsRecipientWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}